const env = import.meta.env.VITE_APP_ENV;
const reviewAppId = import.meta.env.VITE_APP_REVIEW_APP_ID;
import countriesAndLanguages from './countriesAndLocales.js';

const config = {
  env,
  i18n: countriesAndLanguages,
  themeConfig: {
    bettermile: {
      disablePoweredBy: true
    }
  },
  timezone: {
    default: 'Europe/Berlin'
  },
  // This property is set during initialization of the widget.
  // Possible widget configuration fields:
  // - disable5StarRating
  // - postCodeTextInput
  // - disableDepositPermission
  // - disableDeliverToNeighbour
  // - disableFromAddress
  // - disableToAddress
  // - disableOverview
  // - gdprApproved
  // - disableMoreInfoLink
  // - hostHostname: hostname of the embedding page, set by the helper script
  widgetConfiguration: {},
  reviewAppId: reviewAppId
};

export function setWidgetConfig(widgetConfig) {
  config.widgetConfiguration = widgetConfig;
}

export default config;
